export abstract class DomainError<
  Code extends string = string,
  Details extends object = Record<string, never>,
> extends Error {
  protected constructor(
    name: string,
    public readonly code: Code,
    message: string,
    public readonly details: Readonly<Details>,
  ) {
    super(message);
    this.name = name;
  }
}

export class InvalidTransitionError extends DomainError<"INVALID_TRANSITION"> {
  constructor(
    public readonly from: string,
    public readonly event: string,
  ) {
    super("InvalidTransitionError", "INVALID_TRANSITION", `Cannot apply '${event}' from status '${from}'`, {});
  }
}

export class PreconditionFailedError extends DomainError<"PRECONDITION_FAILED"> {
  constructor(message: string) {
    super("PreconditionFailedError", "PRECONDITION_FAILED", message, {});
  }
}

export class NotFoundError extends DomainError<"NOT_FOUND"> {
  constructor(
    public readonly resourceType: string,
    // Failed lookups can carry raw, unvalidated resource locators.
    public readonly resourceId: string,
  ) {
    super("NotFoundError", "NOT_FOUND", `${resourceType}/${resourceId} not found`, {});
  }
}

export class SlotConflictError extends DomainError<"SLOT_CONFLICT"> {
  constructor(message: string) {
    super("SlotConflictError", "SLOT_CONFLICT", message, {});
  }
}
